import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { MappedLink } from "@insite/content-library/Widgets/Header/MainNavigation";
import GridContainer, { GridContainerProps, GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridWidths } from "@insite/mobius/GridItem";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { navigationInteraction } from "@WhiteCap/Common/Utillities/CustomTracking";
import React, { useState } from "react";
import { css } from "styled-components";

export interface CategorySectionStyles {
    CategoryContainer: GridContainerProps;
    CategoryFirstGridItem: GridItemProps;
    CategorySecondGridItem: GridItemProps;
    leftMegaMenuItem: GridItemProps;
    leftMegaMenuLink: LinkPresentationProps;
    rightMegaMenuItem: GridItemProps;
    rightMegaMenuStaticLink: GridItemProps;
    rightMegaMenuLink: LinkPresentationProps;
    rightMegaMenuChildLink: LinkPresentationProps;
    PromoGridItem: GridItemProps;
    PromoOuterGridItem: GridItemProps;
    PromoImage: LazyImageProps;
    PromoImageDescription: LinkPresentationProps;
    PromoImageDetailInfo: TypographyProps;
    PromoButtonLink: LinkPresentationProps;
    PromoDangeouslyTag?: GridItemProps;
    ulList?: InjectableCss;
    ulContainer?: InjectableCss;
}

export const CategorySectionStyles: CategorySectionStyles = {
    CategoryContainer: {
        css: css`
            margin: 0px;
            max-width: 1280px !important;
            width: 100%;
            > ${GridOffset} {
                width: 100%;
                margin: auto;
                > ${GridWrapper} {
                    max-width: 1280px !important;
                    width: 100%;
                }
            }
        `,
    },
    CategoryFirstGridItem: {
        // width: 3,
        css: css`
            padding: 7px 5px;
            max-width: 18.5%;
            flex-basis: 18.5%;
            flex-direction: column;
            overflow: visible;
            min-height: 100%;
            &::-webkit-scrollbar {
                width: 4px;
            }

            &::-webkit-scrollbar-track {
                background: ${getColor("common.background")};
            }

            &::-webkit-scrollbar-thumb {
                background-color: ${getColor("text.accent")};
                border-radius: 7px;
            }
        `,
    },
    CategorySecondGridItem: {
        // width: 10,
        css: css`
            max-width: 81%;
            flex-basis: 81%;
            padding: 20px;
            height: 100%;
        `,
    },
    leftMegaMenuItem: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
            width: 100%;
            padding: 7px 5px;
            height: 100%;
            border-bottom: 1px solid #858585;
            &:hover {
                a {
                    span {
                        color: black !important;
                    }
                }
            }
            ::after {
                color: #000;
                content: "\0025B8";
                position: absolute;
                right: 2px;
            }
        `,
    },
    leftMegaMenuLink: {
        css: css`
            white-space: normal;
            word-break: normal;
            text-align: left;
            text-decoration: none !important;
            &:hover,
            &:focus {
                text-decoration: none !important;
            }
            span {
                color: inherit !important;
                font-size: 12px !important;
            }
        `,
    },
    rightMegaMenuItem: {
        css: css`
            border: 2px solid black;
            display: flex;
            flex-direction: column;
            /* max-height: 450px;
            height: 100%; */
            /* overflow: hidden auto; */
            min-height: 100%;
            max-height: 100vh;
            height: max-content;
            /* li {
                ::after {
                    color: #000;
                    content: "\0025B8";
                    position: absolute;
                    right: -15px;
                }
            } */
        `,
    },
    rightMegaMenuStaticLink: {
        css: css`
            color: ${getColor("text.main")};
            flex-basis: 100%;
            max-width: 100%;
            margin: 0 0 22px 0 !important;
            padding: 0px;
            font-weight: bold;
            cursor: pointer;
            ::after {
                color: #000;
                content: "\0025B8";
                position: absolute;
                right: -15px;
            }
            &:hover {
                text-decoration: underline;
            }
        `,
    },
    rightMegaMenuLink: {
        css: css`
            font-weight: bold;
            position: relative;
            > ${TypographyStyle} {
                color: ${getColor("text.main")};
                white-space: inherit;
                ::after {
                    color: #000;
                    content: "\0025B8" !important;
                    position: absolute;
                    padding: 0px !important;
                    right: -12px;
                }
            }
            &:hover {
                span {
                    color: ${getColor("text.main")} !important;
                    text-decoration: underline;
                }
            }
        `,
    },
    rightMegaMenuChildLink: {
        css: css`
            font-weight: normal;
            > ${TypographyStyle} {
                text-indent: 20px;
                white-space: nowrap;
                display: inline;
                font-size: 12px;
                font-weight: 400;
                color: #000;
                &:hover {
                    color: #000 !important;
                    text-decoration: underline;
                }
            }
        `,
    },
    PromoGridItem: {
        css: css`
            max-width: 100%;
            flex-basis: 100%;
            flex-direction: column;
        `,
    },
    PromoOuterGridItem: {
        css: css`
            max-width: 100%;
            flex-basis: 100%;
            flex-direction: column;
        `,
    },
    PromoImage: {
        css: css`
            width: 200px;
            height: 200px;
        `,
    },
    PromoImageDescription: {},
    PromoImageDetailInfo: {
        css: css`
            color: ${getColor("text.main")};
        `,
    },
    PromoButtonLink: {},
    ulList: {
        css: css``,
    },
    ulContainer: {
        css: css`
            display: flex;
            overflow-x: auto;
            background: #ebebeb;
            height: 100%;
            left: 20.3125%;
            padding: 2.4rem;
            position: absolute;
            right: 0;
            top: 0;
            > ul {
                align-content: flex-start;
                align-items: flex-start;
                background-color: transparent;
                display: flex;
                flex-basis: auto;
                flex-flow: column;
                flex-wrap: wrap;
                justify-content: flex-start;
                width: 100%;
                > li {
                    text-align: left;
                    width: 33%;
                    margin-bottom: 5px;
                    padding: 0 3rem 0 1rem;
                    > a {
                        white-space: normal;
                    }
                }
            }
        `,
    },
};

const CategorySectionComponent = ({ link, onHandleClose }: { link: MappedLink; onHandleClose: Function }) => {
    const [activeChildIndex, setActiveChildIndex] = useState<number>(0);
    const [focusedLeftIndex, setFocusedLeftIndex] = useState<number>(0);
    const [showRightSection, setShowRightSection] = useState<boolean>(true);

    const focusLeftMenuItem = (index: number) => {
        const nextItem = document.querySelector(`[data-menu-index="${index}"]`);
        const nextLink = nextItem?.querySelector<HTMLAnchorElement>("a.Category-mega-menu-left-link");
        if (nextLink) {
            setFocusedLeftIndex(index);
            setShowRightSection(false);
            nextLink.focus();
            return true;
        }
        return false;
    };

    const focusFirstRightLink = () => {
        const firstLink = document.querySelector<HTMLAnchorElement>(
            "a.Category-mega-menu-right-link, a.Category-mega-menu-right-child-link",
        );
        firstLink?.focus();
    };

    const handleMouseEnter = (index: number, categoryName: string) => {
        setActiveChildIndex(index);
        setFocusedLeftIndex(index);
        setShowRightSection(true);
    };

    const handleMouseLeave = () => {
        setShowRightSection(false);
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        switch (e.key) {
            case "ArrowDown":
            case "ArrowUp":
                e.preventDefault();
                break;
            case "Escape":
                e.preventDefault();
                e.stopPropagation();
                onHandleClose();
                break;
        }
    };

    const handleBlur = (e: React.FocusEvent) => {
        const relatedTarget = e.relatedTarget as HTMLElement;
        if (relatedTarget) {
            const isMovingToSubmenu = relatedTarget.closest(".right-parent-grid-item");
            const isMovingToMenuItem = relatedTarget.closest(".Category-mega-menu-left-grid-item");

            if (isMovingToSubmenu || isMovingToMenuItem) {
                return;
            }
        }

        setTimeout(() => {
            const activeElement = document.activeElement;
            const isInMenu =
                activeElement?.closest(".Category-mega-menu-left-grid-item") ||
                activeElement?.closest(".right-parent-grid-item");
            if (!isInMenu) {
                setShowRightSection(false);
                onHandleClose();
            }
        }, 150);
    };
    const styles = CategorySectionStyles;

    const sendDataLayerAndHandleClose = (navigationCategory: string, navigationClickText: string) => {
        navigationInteraction({
            event: "navigation_interaction",
            navigation_category: `Categories - ${navigationCategory}`,
            navigation_click: navigationClickText,
        });

        onHandleClose();
    };

    const isRightSectionTabbable = showRightSection;

    return (
        <>
            {link.children && link?.children?.length > 0 && (
                <GridContainer {...styles.CategoryContainer}>
                    <GridItem {...styles.CategoryFirstGridItem}>
                        {link.children!.map((child: MappedLink, childIndex: number) => (
                            <GridItem
                                className="Category-mega-menu-left-grid-item"
                                style={{
                                    backgroundColor: activeChildIndex === childIndex ? "#fc3" : "initial",
                                    cursor: "pointer",
                                    position: "relative",
                                }}
                                {...styles.leftMegaMenuItem}
                                width={(12 / link.numberOfColumns!) as GridWidths}
                                key={`left-grid-item_${childIndex}`}
                                data-menu-index={childIndex}
                                onMouseOver={() => handleMouseEnter(childIndex, child.title)}
                                onMouseLeave={handleMouseLeave}
                                as="li"
                            >
                                <Link
                                    className="Category-mega-menu-left-link"
                                    {...styles.leftMegaMenuLink}
                                    href={child.url}
                                    data-category-name={`selectedCategoryName_${child.title}`}
                                    style={{
                                        color: activeChildIndex === childIndex ? "#fff" : "#000",
                                        cursor: "pointer",
                                        textDecoration: "none",
                                    }}
                                    onClick={() => sendDataLayerAndHandleClose(child.title, child.title)}
                                    onBlur={handleBlur}
                                    onKeyDown={(e: React.KeyboardEvent) => {
                                        handleKeyDown(e);
                                    }}
                                    role="menuitem"
                                    aria-haspopup={child.children && child.children.length > 0 ? "true" : undefined}
                                    aria-expanded={
                                        activeChildIndex === childIndex && child.children && child.children.length > 0
                                            ? "true"
                                            : undefined
                                    }
                                >
                                    {child.title}
                                </Link>
                                {child.children && child.children.length > 0 && (
                                    <button
                                        className="category-menu-arrow"
                                        type="button"
                                        aria-label={`Expand submenu for ${child.title}`}
                                        aria-expanded={showRightSection && activeChildIndex === childIndex}
                                        aria-controls={`submenu-${childIndex}`}
                                        style={{
                                            position: "absolute",
                                            right: "2px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                            fontSize: "12px",
                                            padding: "5px",
                                            width: "20px",
                                            height: "100%",
                                        }}
                                        onBlur={handleBlur}
                                        onKeyDown={e => {
                                            if (e.key === "Tab" && !e.shiftKey && showRightSection) {
                                                e.preventDefault();
                                                requestAnimationFrame(focusFirstRightLink);
                                                return;
                                            }
                                            if (e.key === "Enter" || e.key === " ") {
                                                e.preventDefault();
                                                setActiveChildIndex(childIndex);
                                                setFocusedLeftIndex(childIndex);
                                                setShowRightSection(true);
                                                requestAnimationFrame(focusFirstRightLink);
                                            } else if (e.key === "Escape") {
                                                e.preventDefault();
                                                onHandleClose();
                                            }
                                        }}
                                        onClick={() => {
                                            setActiveChildIndex(childIndex);
                                            setShowRightSection(true);
                                            requestAnimationFrame(focusFirstRightLink);
                                        }}
                                    />
                                )}
                            </GridItem>
                        ))}
                    </GridItem>
                    <GridItem
                        {...styles.CategorySecondGridItem}
                        className={`right-parent-grid-item ${showRightSection ? "show-right-section" : ""}`}
                        role="menu"
                        aria-label="Submenu"
                    >
                        {link.children &&
                            link.children.map(
                                (child: MappedLink, childIndex: number) =>
                                    activeChildIndex === childIndex && (
                                        <StyledWrapper key={childIndex} {...styles.ulContainer}>
                                            {child.children && (
                                                <ul
                                                    data-test-selector={`linksFor_${child.title}`}
                                                    {...styles.ulList}
                                                    role="menu"
                                                    aria-label={`Submenu for ${child.title}`}
                                                >
                                                    {child.children.map((leafChild: MappedLink, index: number) => {
                                                        const leafChildren = leafChild.children as
                                                            | MappedLink[]
                                                            | undefined;
                                                        const leafHasChildren = !!leafChildren?.length;

                                                        return (
                                                            <li key={`secondLvl_${index}`}>
                                                                <Link
                                                                    className="Category-mega-menu-right-link"
                                                                    {...styles.rightMegaMenuLink}
                                                                    href={leafChild.url}
                                                                    data-test-selector={leafChild.title}
                                                                    data-submenu-item="true"
                                                                    tabIndex={isRightSectionTabbable ? 0 : -1}
                                                                    onClick={() =>
                                                                        sendDataLayerAndHandleClose(
                                                                            child.title,
                                                                            leafChild.title,
                                                                        )
                                                                    }
                                                                    onKeyDown={(e: React.KeyboardEvent) => {
                                                                        if (e.key === "Escape") {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            setShowRightSection(false);
                                                                            requestAnimationFrame(() => {
                                                                                focusLeftMenuItem(childIndex);
                                                                            });
                                                                            return;
                                                                        }

                                                                        if (e.key === "Tab" && e.shiftKey) {
                                                                            const allRightLinks = Array.from(
                                                                                document.querySelectorAll<HTMLAnchorElement>(
                                                                                    "a.Category-mega-menu-right-link, a.Category-mega-menu-right-child-link",
                                                                                ),
                                                                            );

                                                                            const currentLink =
                                                                                e.currentTarget as HTMLAnchorElement;
                                                                            const isFirstRightLink =
                                                                                allRightLinks[0] === currentLink;

                                                                            if (isFirstRightLink) {
                                                                                e.preventDefault();
                                                                                setShowRightSection(false);
                                                                                focusLeftMenuItem(activeChildIndex!);
                                                                                return;
                                                                            }
                                                                        }

                                                                        if (e.key === "Tab" && !e.shiftKey) {
                                                                            const allRightLinks = Array.from(
                                                                                document.querySelectorAll<HTMLAnchorElement>(
                                                                                    "a.Category-mega-menu-right-link, a.Category-mega-menu-right-child-link",
                                                                                ),
                                                                            );
                                                                            const currentLink =
                                                                                e.currentTarget as HTMLAnchorElement;
                                                                            const isLastRightLink =
                                                                                allRightLinks[
                                                                                    allRightLinks.length - 1
                                                                                ] === currentLink;

                                                                            if (isLastRightLink && !leafHasChildren) {
                                                                                const nextLeftIndex = childIndex + 1;
                                                                                const moved =
                                                                                    focusLeftMenuItem(nextLeftIndex);
                                                                                setShowRightSection(false);
                                                                                if (moved) {
                                                                                    e.preventDefault();
                                                                                } else {
                                                                                    onHandleClose();
                                                                                }
                                                                            }
                                                                        }
                                                                    }}
                                                                    onFocus={(e: React.FocusEvent) => {
                                                                        const target =
                                                                            e.currentTarget as HTMLAnchorElement;
                                                                        target.setAttribute(
                                                                            "data-parent-index",
                                                                            childIndex.toString(),
                                                                        );
                                                                    }}
                                                                    role="menuitem"
                                                                    style={{ textDecoration: "none" }}
                                                                    aria-label={`${leafChild.title}, submenu item for ${child.title}`}
                                                                >
                                                                    {leafChild.title}
                                                                </Link>
                                                                {leafHasChildren && (
                                                                    <ul
                                                                        data-test-selector={`linksFor_${leafChild.title}`}
                                                                    >
                                                                        {leafChildren!.map(
                                                                            (
                                                                                subLeafChild: MappedLink,
                                                                                subIndex: number,
                                                                            ) => (
                                                                                <li key={`thirdLvl_${subIndex}`}>
                                                                                    <Link
                                                                                        className="Category-mega-menu-right-child-link"
                                                                                        {...styles.rightMegaMenuChildLink}
                                                                                        href={subLeafChild.url}
                                                                                        data-test-selector={
                                                                                            subLeafChild.title
                                                                                        }
                                                                                        data-submenu-item="true"
                                                                                        tabIndex={
                                                                                            isRightSectionTabbable
                                                                                                ? 0
                                                                                                : -1
                                                                                        }
                                                                                        onClick={() =>
                                                                                            sendDataLayerAndHandleClose(
                                                                                                child.title,
                                                                                                subLeafChild.title,
                                                                                            )
                                                                                        }
                                                                                        onKeyDown={(
                                                                                            e: React.KeyboardEvent,
                                                                                        ) => {
                                                                                            if (e.key === "Escape") {
                                                                                                e.preventDefault();
                                                                                                e.stopPropagation();
                                                                                                setShowRightSection(
                                                                                                    false,
                                                                                                );
                                                                                                requestAnimationFrame(
                                                                                                    () => {
                                                                                                        focusLeftMenuItem(
                                                                                                            childIndex,
                                                                                                        );
                                                                                                    },
                                                                                                );
                                                                                                return;
                                                                                            }

                                                                                            if (
                                                                                                e.key === "Tab" &&
                                                                                                e.shiftKey
                                                                                            ) {
                                                                                                const allRightLinks =
                                                                                                    Array.from(
                                                                                                        document.querySelectorAll<HTMLAnchorElement>(
                                                                                                            "a.Category-mega-menu-right-link, a.Category-mega-menu-right-child-link",
                                                                                                        ),
                                                                                                    );

                                                                                                const currentLink =
                                                                                                    e.currentTarget as HTMLAnchorElement;
                                                                                                const isFirstRightLink =
                                                                                                    allRightLinks[0] ===
                                                                                                    currentLink;

                                                                                                if (isFirstRightLink) {
                                                                                                    e.preventDefault();
                                                                                                    setShowRightSection(
                                                                                                        false,
                                                                                                    );
                                                                                                    focusLeftMenuItem(
                                                                                                        activeChildIndex!,
                                                                                                    );
                                                                                                    return;
                                                                                                }
                                                                                            }

                                                                                            if (
                                                                                                e.key === "Tab" &&
                                                                                                !e.shiftKey
                                                                                            ) {
                                                                                                const allRightLinks =
                                                                                                    Array.from(
                                                                                                        document.querySelectorAll<HTMLAnchorElement>(
                                                                                                            "a.Category-mega-menu-right-link, a.Category-mega-menu-right-child-link",
                                                                                                        ),
                                                                                                    );

                                                                                                const currentLink =
                                                                                                    e.currentTarget as HTMLAnchorElement;
                                                                                                const isLastLink =
                                                                                                    allRightLinks[
                                                                                                        allRightLinks.length -
                                                                                                            1
                                                                                                    ] === currentLink;

                                                                                                if (isLastLink) {
                                                                                                    const nextLeftIndex =
                                                                                                        childIndex + 1;
                                                                                                    setShowRightSection(
                                                                                                        false,
                                                                                                    );

                                                                                                    if (
                                                                                                        focusLeftMenuItem(
                                                                                                            nextLeftIndex,
                                                                                                        )
                                                                                                    ) {
                                                                                                        e.preventDefault();
                                                                                                    } else {
                                                                                                        onHandleClose();
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        {subLeafChild.title}
                                                                                    </Link>
                                                                                </li>
                                                                            ),
                                                                        )}
                                                                    </ul>
                                                                )}
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            )}
                                        </StyledWrapper>
                                    ),
                            )}
                    </GridItem>
                </GridContainer>
            )}
        </>
    );
};

export default CategorySectionComponent;
